import hash from "@emotion/hash"
import styled from "@emotion/styled"
import { useConsole } from "contexts/Console"
import getMediaQuery from "css/breakpoints"
import { fullGrid } from "css/grid"
import { body100, headline50 } from "css/text"
import { motion, useScroll, useTransform } from "framer-motion"
import { useRef } from "react"
// import Countdown from "./Countdown"
import { colors, testimoneeGradientVar } from "../colors"
import Logos from "components/logos/Logos"

const Root = styled.section`
  ${colors}
  ${fullGrid}
  background: #fff;
  grid-column: doc;
  margin-block-start: -100vh;
  overflow: hidden;
  place-items: center;
  position: relative;

  > div {
    ${fullGrid}
    grid-column: doc;
    transform: translate3d(0, 0, 0);
  }
`

const Content = styled(motion.div, {
  shouldForwardProp: prop => prop !== "gradient",
})`
  background: ${({ gradient }) => (gradient ? `${gradient}` : `var(${testimoneeGradientVar})`)};
  background-clip: text;
  display: inline-table; // Fix text clipping in Firefox 135 ¯\_(ツ)_/¯
  grid-column: main;
  padding-block-start: 130vh;
  padding-block-end: 20vh;
  position: relative;
  // text-wrap: balance;
  -webkit-text-fill-color: transparent;
  will-change: transform;

  ${getMediaQuery("m")} {
    grid-column: col 3 / span 9;
  }

  ${getMediaQuery("m")} {
    grid-column: 4 / span 8;
  }
`

const Title = styled.h3`
  ${body100}
  margin-bottom: 1ex;
`

const Paragraph = styled.p`
  ${headline50}
  text-align: center;
`

export default function Introduction({ event, ...props }) {
  const rroot = useRef()
  const console = useConsole()

  // const { text, discipline = "all" } = props.content[0]
  const text = props.content?.find(item => item.text)?.text
  const discipline = props.content?.find(item => item.discipline)?.discipline || "all"
  const gradient = props.content?.find(item => item.gradient)?.gradient
  const caption = props.content?.find(item => item.text?.caption)?.text?.caption
  const image = props.content?.find(item => item.text?.image)?.text?.image
  const images = (Array.isArray(image) ? image : [image]).flatMap(logo => {
    const sources = Array.isArray(logo?.sources) ? logo.sources.filter(Boolean) : []
    const sourcesLocalized = Array.isArray(logo?.sources_localized) ? logo.sources_localized.filter(Boolean) : []

    return sources.length || sourcesLocalized.length ? [{ ...logo, sources, sources_localized: sourcesLocalized }] : []
  })

  // const startDate = event?.start_date
  // const endDate = event?.end_date
  // const labels = event?.labels || []
  // const name = event?.name
  // const timeZone = event?.event_time_zone || "UTC"

  const { scrollYProgress } = useScroll({ target: rroot, offset: ["start start", "end start"] })

  const y = useTransform(scrollYProgress, [0, 1], ["-25vh", "15vh"])

  const gradientColors = (gradient || text.gradient)?.colors?.map(g => `rgb(${g.color} / ${g.opacity})`).join(", ")
  const gradientString = gradientColors && `linear-gradient(${text.gradient?.angle || "90deg"}, ${gradientColors})`

  console.log("TestimoneeIntroduction(%o)", { props, event })
  console.verbose("\n•••.>> logo", images)

  return (
    <Root ref={rroot}>
      <div>
        <Content className={`tcs${hash(discipline)}`} style={{ y }} gradient={gradientString}>
          {text.kicker && <Title>{text.kicker}</Title>}
          {/* {startDate && <Countdown startDate={startDate} endDate={endDate} labels={labels} timeZone={timeZone} name={name} />} */}
          <Paragraph dangerouslySetInnerHTML={{ __html: text.paragraph }} />
          <Logos images={images} caption={caption} />
        </Content>
      </div>
    </Root>
  )
}
